import { action } from "typesafe-actions";
import { ICampaign, ICampaignState } from "./campaign.types";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
    closeLoaderWithMessage,
    convertLoaderCompleted,
    convertLoaderProgress,
    openLoaderWithMessage,
    saveLoaderCompleted,
    saveLoaderProgress,
    showMessage,
} from "../messages/messagesActions";
import { IQueryParams, ISearchQueryParams } from "../common/common.types";
import { getSearchQuery, getSearchQueryV2 } from "../common/helpers";
import { makeApiCall } from "../../helpers/postRequest";
import { endPoints } from "../../constants/endPoints";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { getDataTablev2InitialDate } from "../../components/TableV2/helpers/dataTableV2DatesFilter";
import { formatDate, formatDate2 } from "../../helpers";

export const FETCH_CAMPAIGN_LIST_PROGRESS = "FETCH_CAMPAIGN_LIST_PROGRESS";
export const FETCH_CAMPAIGN_LIST_SUCCESS = "FETCH_CAMPAIGN_LIST_SUCCESS";
export const FETCH_CAMPAIGN_LIST_FAILED = "FETCH_CAMPAIGN_LIST_FAILED";

export const fetchCampaignsListProgress = () => action(FETCH_CAMPAIGN_LIST_PROGRESS);
export const fetchCampaignsListSuccess = (list: ICampaign[], totalRecords: number) =>
    action(FETCH_CAMPAIGN_LIST_SUCCESS, { list, totalRecords });
export const fetchCampaignsListFailed = () => action(FETCH_CAMPAIGN_LIST_FAILED);


// export const fetchCampaignsListAsync =
//     (
//         queryParams: ISearchQueryParams
//     ): ThunkAction<void, IStoreState, {}, AnyAction> =>
//         async (dispatch, getState) => {
//             try {
//                 dispatch(fetchCampaignsListProgress());

//                 let url = getSearchQueryV2(queryParams);


//                 const res = await api.get(`${endPoints.campaign.getCampaign}?${url}`);
//                 const data: ICampaign[] = res.data.data || [];
//                 const totalRecords = res.data.totalRecords || 0;

//                 dispatch(fetchCampaignsListSuccess(data, totalRecords));
//             } catch (err: any) {
//                 dispatch(fetchCampaignsListFailed());
//                 dispatch(
//                     showMessage({
//                         message: err?.response?.data?.message || "Failed to fetch campaign",
//                         type: "error",
//                         displayAs: "snackbar",
//                     })
//                 );
//             }
//         };

export const fetchCampaignsListAsync =
    (queryParams: ISearchQueryParams): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch, getState) => {
            try {
                dispatch(fetchCampaignsListProgress());

                const { customFilters, advancedFilters, ...rest } = queryParams as any;

                const mergedAdvancedFilters = Array.isArray(advancedFilters) ? [...advancedFilters] : [];

                if (customFilters) {
                    Object.keys(customFilters).forEach((key) => {
                        if (customFilters[key]) {
                            mergedAdvancedFilters.push({
                                column: [key],
                                logicalOperator: "AND",
                                operator: "EQUAL",
                                value: customFilters[key],
                            });
                        }
                    });
                }

                let url = getSearchQueryV2({
                    ...rest,
                    advancedFilters: mergedAdvancedFilters,
                });

                const res = await api.get(`${endPoints.campaign.getCampaign}?${url}`);
                const data: ICampaign[] = res.data.data || [];
                const totalRecords = res.data.totalRecords || 0;

                dispatch(fetchCampaignsListSuccess(data, totalRecords));
            } catch (err: any) {
                dispatch(fetchCampaignsListFailed());
                dispatch(
                    showMessage({
                        message: err?.response?.data?.message || "Failed to fetch campaign",
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
            }
        };

// Fetch Single Partner Master Actions
export const FETCH_CAMPAIGN_PROGRESS = "FETCH_CAMPAIGN_PROGRESS";
export const FETCH_CAMPAIGN_SUCCESS = "FETCH_CAMPAIGN_SUCCESS";
export const FETCH_CAMPAIGN_FAILED = "FETCH_CAMPAIGN_FAILED";

export const fetchCampaignProgress = () => action(FETCH_CAMPAIGN_PROGRESS);
export const fetchCampaignSuccess = (campaign: ICampaign) =>
    action(FETCH_CAMPAIGN_SUCCESS, { campaign });
export const fetchCampaignFailed = (errorMessage: string) =>
    action(FETCH_CAMPAIGN_FAILED, { errorMessage });

export const fetchCampaignAsync =
    (campaignId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch, getState) => {
            try {
                dispatch(fetchCampaignProgress());

                const res = await api.get(`${endPoints.campaign.getCampaign}?campaign_uuid=${campaignId}`);
                const data: ICampaign = res.data.data[0];

                dispatch(fetchCampaignSuccess(data));
            } catch (err: any) {
                dispatch(
                    fetchCampaignFailed(
                        err?.response?.data?.message || "Failed to fetch campaign"
                    )
                );
                dispatch(
                    showMessage({
                        message: err?.response?.data?.message || "Failed to fetch campaign",
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
            }
        };

// Upsert Campaign Actions
export const upsertCampaignAsync =
    (
        campaignData: ICampaign,

        onCallBack: (isSuccess?: boolean, data?: ICampaign) => void
    ): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch, getState) => {
            try {

                dispatch(openLoaderWithMessage("Saving campaign, please wait..."));
                const {
                    create_ts,
                    insert_ts,
                    campaign_unique_id,
                    created_by_name, created_by_uuid, modified_by_name, modified_by_uuid,
                    ...payload
                } = campaignData;

                const res = await api.post(endPoints.campaign.upsertCampaign, payload);

                const data: ICampaign = res.data.data;
                dispatch(
                    showMessage({
                        message: res.data.message,
                        type: "success",
                        displayAs: "snackbar",
                    })
                );
                onCallBack(true, data);
            } catch (err: any) {
                dispatch(
                    showMessage({
                        message: err?.response?.data?.message || "Failed to save campaign",
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
                onCallBack(false);
            }
            finally {
                dispatch(closeLoaderWithMessage());
            }
        };

export const CLEAR_CAMPAIGN_STATE = "CLEAR_CAMPAIGN_STATE";
export const CLEAR_CAMPAIGN = "CLEAR_CAMPAIGN_MASTER";
export const clearCampaignState = () => action(CLEAR_CAMPAIGN_STATE);
export const clearCampaign = () => action(CLEAR_CAMPAIGN);